module.exports = "<main>\n    <router-outlet></router-outlet>\n    <tfl-option-dialog></tfl-option-dialog>\n</main>\n"


//////////////////
// WEBPACK FOOTER
// ./src/dashboard/app/app.component.html
// module id = 734
// module chunks = 0